import { render, staticRenderFns } from "./set-rules.vue?vue&type=template&id=0da39e3e&scoped=true"
import script from "./set-rules.vue?vue&type=script&lang=js"
export * from "./set-rules.vue?vue&type=script&lang=js"
import style0 from "./set-rules.vue?vue&type=style&index=0&id=0da39e3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da39e3e",
  null
  
)

export default component.exports